<template>
  <div class="page-bg">
    <Header :headerTitle="$t('m.userHelp.title')"></Header>
    <div class="u-cell-row" style="margin-top:8px">
      <van-cell :title="$t('m.userHelp.agreementTitle')" is-link size="large" @click="$router.push('/userTreaty')"  />
      <van-cell :title="$t('m.userHelp.oilicyTitle')" is-link size="large" @click="$router.push('/policy')"  />
      <van-cell :title="$t('m.userHelp.rulesTilte')" is-link size="large" @click="$router.push('/ruler')"  />
      <van-cell :title="$t('m.userHelp.notesInboicingTitle')" is-link size="large" @click="$router.push('/invoiceExplain')"  />
      <van-cell v-if="$t('m.userHelp.language')=='zh_CN'" :title="$t('m.userHelp.commonProblemTitle')" is-link size="large" @click="$router.push('/commonProblem')"  />
    </div>
   
  
    <!-- 目前用不上  等待以后需要更改不要删除 -->
    <!-- <div class="help-item">
      <router-link to="/overtimeRules">
        <p>超时费用规则</p>
      </router-link>
    </div> -->
     <!-- <div class="help-item">
      <router-link to="/overTimeRuleClause">
        <p>{{$t('m.userHelp.overTimeRuleClauseTitle')}}</p>
      </router-link>
    </div> -->
  
   
   
    <b-modal
      id="messageBox"
      centered
      :ok-title="$t('m.phone.call')"
      :title="$t('m.phone.serviceTitle')"
      :cancel-title="$t('m.phone.cancel')"
      @ok="handleOk"
    >{{phone}}</b-modal>
    <div v-b-modal.messageBox v-b-modal.modalsm class="call-btn">
      <b-button variant="primary">
        <span>{{$t('m.userHelp.serverTitle')}}</span>
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "userHelp",
  data() {
    return {
      phone: "400-115-0606"
    };
  },
  methods: {
    handleOk: function() {
      window.location.href = "tel:" + this.phone;
    }
  }
};
</script>

<style scoped>
a {
  color: #2c3e50;
}

a:link {
  text-decoration: none;
  color: #2c3e50;
}

p {
  font-family: HiraginoSansGB-W6;
}

.help-item {
  text-align: left;
  height: 65px;
  line-height: 65px;
  padding: 0px 10px;
}

.help-item p {
  border-bottom: 1px solid #d5d5d5;
  padding-left: 20px;
}

.help-item:last-child p {
  border-bottom: none;
}

.call-btn {
  width: 100%;
  position: absolute;
  bottom: 20px;
  text-align: center;
}

.call-btn button {
  background-color: #0066B1;
  width: 90%;
  padding: 10px;
}
</style>
